module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/arIItV/tc-custom/9781423619765.jpg?1718251155513",
      "alt": "This image is the cover for the book Rustic Elegance"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rustic Elegance\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A collection of breathtaking log cabins where everything new is old again, from the author of "), _c('i', [_vm._v("Ralph Kylloe’s Rustic Living")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v(" Exuding luxury and comfort, history and innovation, here are thirteen newly handcrafted log and stone homes that surpass all expectations of quality and creativity. All are the creations of Larry Pearson, AIA, who is recognized as a leader in rustic design. These luxurious cabins from Montana, Wyoming, Connecticut, Wisconsin, Minnesota and California are replete with hand-hewn logs, dry-stacked stone, artistic doors and staircases, and furnishings that meld modern convenience with age-old beauty."), _c('br'), _c('br'), _vm._v(" Pearson Design Group was the recipient of "), _c('i', [_vm._v("Mountain Living Magazine")]), _vm._v("’s prestigious 2009 Home of the Year Award and has been featured on HGTV’S "), _c('i', [_vm._v("Spectacular Homes")]), _vm._v(".")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ralph Kylloe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ralph Kylloe received his EdD from Boston University and has taught at the university level for many years. He is a leading authority on rustic furniture and owner of the aplh Kylloe Gallery at Lake George in New York's Adirondack Mountains. His previous books include Fishing Camps, Rustic Architecture and Design, and Cabins & Camps.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0